var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_694",
    "data-name": "Group 694",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.272,
    height: 62.591,
    viewBox: "0 0 66.272 62.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1948",
    "data-name": "Rectangle 1948",
    width: 22.091,
    height: 3.682,
    transform: "translate(22.091)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1949",
    "data-name": "Rectangle 1949",
    width: 7.363,
    height: 3.682,
    transform: "translate(14.727 3.682)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M134.837,98.029V90.665h-3.682V86.983h-3.682V83.3H120.11V79.62H98.019V83.3H90.655v3.682H86.973v3.682H83.292v7.364H79.61v18.409h3.682V123.8h3.682v3.682h3.682v3.682h7.363v3.682H120.11v-3.682h7.363v-3.682h3.682V123.8h3.682v-7.364h3.682V98.029Zm-22.091,29.454h-7.363v-7.364h7.363Zm0-11.045h-7.363V86.983h7.363Z",
    transform: "translate(-75.928 -75.938)",
    fill: "#49b7ab"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1950",
    "data-name": "Rectangle 1950",
    width: 7.363,
    height: 3.682,
    transform: "translate(44.181 3.682)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1951",
    "data-name": "Rectangle 1951",
    width: 3.682,
    height: 3.682,
    transform: "translate(11.045 7.364)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1952",
    "data-name": "Rectangle 1952",
    width: 3.682,
    height: 3.682,
    transform: "translate(51.545 7.364)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1953",
    "data-name": "Rectangle 1953",
    width: 3.682,
    height: 3.682,
    transform: "translate(7.363 11.045)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1954",
    "data-name": "Rectangle 1954",
    width: 7.363,
    height: 29.454,
    transform: "translate(29.454 11.045)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1955",
    "data-name": "Rectangle 1955",
    width: 3.682,
    height: 3.682,
    transform: "translate(55.227 11.045)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1956",
    "data-name": "Rectangle 1956",
    width: 3.682,
    height: 7.364,
    transform: "translate(3.682 14.727)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1957",
    "data-name": "Rectangle 1957",
    width: 3.682,
    height: 7.364,
    transform: "translate(58.909 14.727)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1958",
    "data-name": "Rectangle 1958",
    width: 3.682,
    height: 18.409,
    transform: "translate(0 22.091)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1959",
    "data-name": "Rectangle 1959",
    width: 3.682,
    height: 18.409,
    transform: "translate(62.59 22.091)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    "data-name": "Rectangle 1960",
    width: 3.682,
    height: 7.364,
    transform: "translate(58.909 40.5)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1961",
    "data-name": "Rectangle 1961",
    width: 3.682,
    height: 7.364,
    transform: "translate(3.682 40.5)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    width: 3.682,
    height: 3.682,
    transform: "translate(7.363 47.864)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1963",
    "data-name": "Rectangle 1963",
    width: 7.363,
    height: 7.364,
    transform: "translate(29.454 44.182)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1964",
    "data-name": "Rectangle 1964",
    width: 3.682,
    height: 3.682,
    transform: "translate(55.227 47.864)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1965",
    "data-name": "Rectangle 1965",
    width: 3.682,
    height: 3.682,
    transform: "translate(11.045 51.545)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1966",
    "data-name": "Rectangle 1966",
    width: 3.682,
    height: 3.682,
    transform: "translate(51.545 51.545)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1967",
    "data-name": "Rectangle 1967",
    width: 7.363,
    height: 3.682,
    transform: "translate(14.727 55.227)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1968",
    "data-name": "Rectangle 1968",
    width: 7.363,
    height: 3.682,
    transform: "translate(44.181 55.227)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1969",
    "data-name": "Rectangle 1969",
    width: 22.091,
    height: 3.682,
    transform: "translate(22.091 58.909)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.2c7bd89c28e9a8edcda1fdb1cb5a587b.svg";
export { ForwardRef as ReactComponent };